import { useEffect } from "react";
import Cookies from "js-cookie";
import ReactGA from "react-ga4";

export default function GAInitializer() {
    useEffect(() => {
        const interval = setInterval(() => {
            if (!process.env.REACT_APP_GA_MEASUREMENT_ID) {
                console.warn("Google Analytics Measurement ID is not set");
                clearInterval(interval);

                return;
            }

            const consent = Cookies.get("user_cookie_consent");

            if (consent === "true" && !(window as any)._gaInitialized) {
                ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID!);
                (window as any)._gaInitialized = true;
                (window as any).ReactGA = ReactGA;
                ReactGA.send({ hitType: "pageview", page: window.location.pathname });

                console.log("Google Analytics initialized");
                clearInterval(interval);
            }
        }, 500);
    }, []);

    return null;
}
